import { CONTACT_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendCommission: builder.mutation({
      query: (data) => ({
        url: `${CONTACT_URL}/commission`,
        method: 'POST',
        body: data,
      }),
    }),
    subscribeNewsletter: builder.mutation({
      query: (data) => ({
        url: `${CONTACT_URL}/newsletter`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useSendCommissionMutation, useSubscribeNewsletterMutation } =
  contactApiSlice;
